<template>
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.25 13.125C26.25 20.3737 20.3737 26.25 13.125 26.25C5.87626 26.25 0 20.3737 0 13.125C0 5.87626 5.87626 0 13.125 0C20.3737 0 26.25 5.87626 26.25 13.125ZM11.1562 13.125C11.1562 14.2123 12.0377 15.0938 13.125 15.0938C14.2123 15.0938 15.0938 14.2123 15.0938 13.125C15.0938 12.0377 14.2123 11.1562 13.125 11.1562C12.0377 11.1562 11.1562 12.0377 11.1562 13.125Z"
      :fill="fillColor"
    />
    <path
      d="M18.0129 17.139L18.5959 13.4345H14.9486V11.0316C14.9486 10.0178 15.4572 9.02913 17.0908 9.02913H18.75V5.8753C18.75 5.8753 17.2449 5.625 15.8065 5.625C12.8014 5.625 10.8391 7.39963 10.8391 10.611V13.4345H7.5V17.139H10.8391V26.0948C11.5094 26.1975 12.1952 26.25 12.8938 26.25C13.5925 26.25 14.2783 26.1975 14.9486 26.0948V17.139H18.0129Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_34_2022"
        x1="13.125"
        y1="0"
        x2="13.125"
        y2="26.1721"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#18ACFE" />
        <stop offset="1" stop-color="#0163E0" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    fillColor: {
      type: String,
      default: "#4D4D4D",
    },
  },
};
</script>


